import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthStore } from "@pos/shared/stores";
import { getMe } from "@pos/shared/api";
import { connectRealtime, disconnectRealtime } from "@pos/shared/realtime";

export function ProtectedLayout() {
  const token = useAuthStore((s) => s.token);
  const deviceId = useAuthStore((s) => s.deviceId);
  const userId = useAuthStore((s) => s.user?.userId);
  const [validating, setValidating] = useState(false);
  const [validated, setValidated] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!token || !userId || !deviceId || validated || validating) return;

    setValidating(true);
    getMe()
      .then((res) => {
        const { store } = useAuthStore.getState();
        if (store) {
          useAuthStore.setState({
            store: {
              ...store,
              shopName: res.data.storeName ?? store.shopName,
              customerId: res.data.customerId,
              groupName: res.data.groupName,
            },
          });
        }
        setValidated(true);
      })
      .catch(() => {
        useAuthStore.getState().clearSession();
        setFailed(true);
      })
      .finally(() => {
        setValidating(false);
      });
  }, [token, userId, deviceId, validated, validating]);

  useEffect(() => {
    if (!validated) return;
    connectRealtime();
    return () => disconnectRealtime();
  }, [validated]);

  if (!token || failed) {
    return <Navigate to="/login" replace />;
  }

  if (!validated) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Validating session...</p>
      </div>
    );
  }

  return <Outlet />;
}
